export const schoolCalendar = {
  title: "School Calendar",
  subtitle: "Academic year 2026/2027 - Important dates and events",
  courseDate: {
    title: "Course start and end dates",
    start: "Course start",
    startDate: "September 9, 2026",
    end: "Course end",
    endDate: "June 21, 2027"
  },
  holidays: {
    title: "Holidays",
    items: [
      {
        name: "Christmas",
        date: "from December 22, 2026 to January 7, 2027 (both inclusive)"
      },
      {
        name: "Entroido (Carnival)",
        date: "February 8, 9 and 10, 2027 (both inclusive)"
      },
      {
        name: "Easter",
        date: "from March 22 to March 29, 2027 (both inclusive)"
      }
    ]
  },
  publicHolidays: {
    title: "Public Holidays",
    items: [
      {
        name: "National Holiday",
        date: "October 12, 2026"
      },
      {
        name: "Immaculate Conception",
        date: "December 8, 2026"
      },
      {
        name: "San Xosé (Father's Day)",
        date: "March 19, 2027"
      },
      {
        name: "Labour Day",
        date: "May 1, 2027"
      },
      {
        name: "Letras Galegas",
        date: "May 17, 2027"
      }
    ]
  },
  nonSchoolDays: {
    title: "Non-school days (Regional Government)",
    items: [
      {
        name: "Día do Ensino",
        date: "December 7, 2026"
      }
    ]
  },
  familyCelebrations: {
    title: "Gándara celebrations (with families)",
    items: [
      {
        name: "Samaín-Magosto",
        date: "October 30, 2026"
      },
      {
        name: "Winter solstice",
        date: "December 21, 2026"
      },
      {
        name: "Entroido",
        date: "February 5, 2027"
      },
      {
        name: "Spring equinox",
        date: "March 18, 2027"
      },
      {
        name: "End-of-year party",
        date: "June 21, 2027"
      }
    ]
  },
  familyMeetings: {
    title: "Family meetings",
    items: [
      {
        name: "Start-of-year family meeting",
        date: "September 7, 2026"
      },
      {
        name: "2nd term family meeting",
        date: "December 14, 2026"
      },
      {
        name: "End-of-year family meeting",
        date: "June 14, 2027"
      }
    ]
  }
};
